import React, { Fragment } from 'react';
import TitleBox from '../../components/common/TitleBox';
import SlotCenter from '../../components/Slot/SlotCenter';

const Casino = ({hotel}) => {
    return (
        <Fragment>
            <TitleBox title={ hotel ? "호텔카지노" : "카지노" } />
            <div className="contents_wrap">
                <SlotCenter  type={ hotel ? "hotelcasino" : "Casino" }/>
            </div>
        </Fragment>
    );
};

export default Casino;


// WEBPACK FOOTER //
// ./src/containers/Slot/Casino.js